import SmartLink from '../../lib/includes/components/component.smartlink';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import React from "react";

import LogoUrl from './../../assets/img/logo.svg';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars, faXmark} from "@fortawesome/pro-light-svg-icons";

const Header = (props) => {
	if (!props.general) return null;

	let headerBtn = props.general.header?.btn;
	let scrolled = props.custom?.scrolled || false;
	let menuToggled = props.menu?.menu_toggled || false;

	const closeMenu = () => {
		if (menuToggled) props.toggleMenu();
	};

	const navItems = props.menu?.menus?.main_menu?.items?.filter(i => i.parent === 0) || [];

	return <header className={"site-header" + (scrolled ? " pinned" : "")}>
		<div className="header-box">

			<div className="header-row">
				
				{/* Mobil-meny knapp – visas endast på mobil via CSS */}
				<div className="col-mobile-menu">
					<button
						onClick={props.toggleMenu}
						className="menu-toggle"
						aria-label={menuToggled ? "Close menu" : "Open menu"}
					>
						<span className="menu-icon">
							<FontAwesomeIcon icon={menuToggled ? faXmark : faBars} />
						</span>
						{menuToggled ? "Close" : "Menu"}
					</button>
				</div>

				{/* Logo */}
				<div className="col-logo">
					<Link to="/" className="logo" onClick={closeMenu}>
						<img src={LogoUrl} alt={props.general.title} />
					</Link>
				</div>

				{/* Nav – centrerad på desktop */}
				<div className="col-nav">
					<ul className="nav">
						{navItems.map((item, i) => (
							<li key={item.id} className="nav-item">
								<SmartLink
									activeClassName="current"
									className="nav-link"
									url={item.url}
									target={item.target}
								>
									{item.title}
								</SmartLink>
							</li>
						))}
					</ul>
				</div>

				{/* Knapp – höger */}
				{headerBtn &&
					<div className="col-aside">
						<SmartLink
							url={headerBtn.url}
							target={headerBtn.target}
							className="button button-primary button-sm"
						>
							{headerBtn.title}
						</SmartLink>
					</div>
				}

			</div>

			{/* Mobil-meny */}
			<div className={"mobile-nav" + (menuToggled ? " open" : "")}>
				<ul className="nav">
					{navItems.map((item, i) => (
						<li key={item.id} className="nav-item">
							<SmartLink
								activeClassName="current"
								className="nav-link"
								url={item.url}
								target={item.target}
								onClick={closeMenu}
							>
								{item.title}
							</SmartLink>
						</li>
					))}
				</ul>
			</div>

		</div>
	</header>
};

export default connect(
	state => ({
		menu: state.menuState,
		general: state.generalState.general,
		custom: state.customState
	}),
	dispatch => ({
		toggleMenu: () => dispatch({ type: 'MENU_TOGGLED' }),
	})
)(Header);